export const  pluralize = function(number, zero, one, four, five) {
    let result;
    number = Math.abs(Math.round(number));

    if (arguments.length === 4) {
        five = four;
        four = one;
        one = zero;
        zero = '';
    }

    if (number === 0) {
        result = zero;
    } else {
        let cases = [2, 0, 1, 1, 1, 2];
        let titles = [one, four, five];
        result = titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    }
    return result === undefined ? '' : result.replace('$', number);
}